import { render, staticRenderFns } from "./resend.vue?vue&type=template&id=3e96d892&"
import script from "./resend.vue?vue&type=script&lang=js&"
export * from "./resend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports